(function () {
  if (window.__sfaQuickAddInit) return;
  window.__sfaQuickAddInit = true;

  // Must match cart-notification.js getSectionsToRender() — max 5 sections per request.
  var NOTIFICATION_SECTIONS = ['cart-notification-product', 'cart-notification-free-ship', 'cart-notification-subtotal', 'cart-upsell', 'cart-icon-bubble'];
  var DESKTOP_MQ = '(min-width: 750px)';

  var ICONS = {
    bag: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 8.5h13l-.9 11a2 2 0 0 1-2 1.8H8.4a2 2 0 0 1-2-1.8l-.9-11Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M8.8 10.5v-4a3.2 3.2 0 0 1 6.4 0v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    close: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 2.5l11 11M13.5 2.5l-11 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    chevron: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3.5L10.5 8L6 12.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.8l7.2 2.7v5.8c0 4.5-3 8.6-7.2 9.9-4.2-1.3-7.2-5.4-7.2-9.9V5.5L12 2.8Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 11.8l2.1 2.1 3.9-3.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var PANEL_HTML =
    '<div class="sfa-modal" role="dialog" aria-modal="true" aria-label="Choose an option">' +
      '<button type="button" class="sfa-modal__close" aria-label="Close">' + ICONS.close + '</button>' +
      '<div class="sfa-modal__header">' +
        '<div class="sfa-modal__icon" aria-hidden="true">' + ICONS.bag + '</div>' +
        '<h2 class="sfa-modal__title"></h2>' +
        '<p class="sfa-modal__subtitle"></p>' +
      '</div>' +
      '<div class="sfa-modal__options"></div>' +
      '<div class="sfa-modal__footer">' +
        ICONS.shield +
        '<span>Secure checkout</span>' +
        '<span class="sfa-modal__footer-dot" aria-hidden="true"></span>' +
        '<span>365-day guarantee</span>' +
      '</div>' +
    '</div>';

  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = doc.getElementById('cart-icon-bubble');
        if (fresh) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  // Adds a variant to the cart. Resolves on success, rejects on failure.
  function addToCart(variantId) {
    var notification = document.querySelector('cart-notification');
    var useDrawer = !!(notification && typeof notification.renderContents === 'function');
    var payload = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (useDrawer) {
      payload.sections = NOTIFICATION_SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (parsed) {
      if (useDrawer && parsed && parsed.sections) {
        try {
          notification.renderContents(parsed);
        } catch (err) {
          refreshCartBubble();
        }
      } else {
        refreshCartBubble();
      }
      return parsed;
    });
  }

  // Direct add via the card button, with Adding…/Added ✓ states.
  function directAdd(btn, variantId) {
    var label = btn.querySelector('.sfa-quick-add__btn-label') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = btn.getAttribute('data-adding-text') || 'Adding…';
    addToCart(variantId)
      .then(function () {
        label.textContent = btn.getAttribute('data-added-text') || 'Added ✓';
        setTimeout(function () {
          label.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        label.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () { label.textContent = original; }, 2500);
      });
  }

  /* ---------------- Variant selector (desktop: in-card, mobile: full-screen) ---------------- */

  var globalOverlay = null; // full-screen container, reused (mobile)
  var openPop = null;       // { root, type: 'card' | 'modal', trigger }

  function fillPanel(root, data) {
    var optionName = (data.option || 'Size');
    var article = /^[aeiou]/i.test(optionName) ? 'an' : 'a';
    root.querySelector('.sfa-modal__title').textContent = 'Choose ' + article + ' ' + optionName;
    root.querySelector('.sfa-modal__subtitle').textContent =
      'Select ' + article + ' ' + optionName.toLowerCase() + ' to add ' + data.title + ' to your cart.';

    var list = root.querySelector('.sfa-modal__options');
    list.innerHTML = '';
    (data.variants || []).forEach(function (variant) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'sfa-modal__option';
      row.setAttribute('data-variant-id', variant.id);
      if (!variant.available) row.disabled = true;

      var right = variant.available
        ? (variant.compareAt ? '<s class="sfa-modal__option-compare">' + variant.compareAt + '</s>' : '') +
          '<span class="sfa-modal__option-price">' + variant.price + '</span>' +
          '<span class="sfa-modal__option-chevron" aria-hidden="true">' + ICONS.chevron + '</span>'
        : '<span class="sfa-modal__option-price">Sold out</span>';

      row.innerHTML =
        '<span class="sfa-modal__option-title"></span>' +
        '<span class="sfa-modal__option-right">' + right + '</span>';
      row.querySelector('.sfa-modal__option-title').textContent = variant.title;
      list.appendChild(row);
    });
  }

  function focusFirstRow(root) {
    var firstRow = root.querySelector('.sfa-modal__option:not(:disabled)');
    var el = firstRow || root.querySelector('.sfa-modal__close');
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function openSelector(data, trigger) {
    closeSelector();
    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
    var card = trigger.closest('.card-wrapper');

    if (isDesktop && card) {
      // In-card popup covering just this product card
      var pop = document.createElement('div');
      pop.className = 'sfa-card-pop';
      pop.innerHTML = PANEL_HTML;
      card.appendChild(pop);
      fillPanel(pop, data);
      pop.addEventListener('click', function (e) {
        if (e.target === pop) closeSelector();
      });
      pop.querySelector('.sfa-modal__close').addEventListener('click', closeSelector);
      openPop = { root: pop, type: 'card', trigger: trigger };
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      focusFirstRow(pop);
    } else {
      // Full-screen centered modal (mobile)
      if (!globalOverlay) {
        globalOverlay = document.createElement('div');
        globalOverlay.className = 'sfa-modal-overlay';
        globalOverlay.hidden = true;
        globalOverlay.innerHTML = PANEL_HTML;
        document.body.appendChild(globalOverlay);
        globalOverlay.addEventListener('click', function (e) {
          if (e.target === globalOverlay) closeSelector();
        });
        globalOverlay.querySelector('.sfa-modal__close').addEventListener('click', closeSelector);
      }
      fillPanel(globalOverlay, data);
      globalOverlay.hidden = false;
      document.documentElement.classList.add('sfa-modal-open');
      openPop = { root: globalOverlay, type: 'modal', trigger: trigger };
      requestAnimationFrame(function () { globalOverlay.classList.add('is-open'); });
      focusFirstRow(globalOverlay);
    }
  }

  function closeSelector() {
    if (!openPop) return;
    var pop = openPop;
    openPop = null;
    if (pop.type === 'card') {
      pop.root.remove();
    } else {
      pop.root.classList.remove('is-open');
      pop.root.hidden = true;
      document.documentElement.classList.remove('sfa-modal-open');
    }
    if (pop.trigger && typeof pop.trigger.focus === 'function') {
      try {
        pop.trigger.focus({ preventScroll: true });
      } catch (err) {
        pop.trigger.focus();
      }
    }
  }

  function handleOptionClick(row) {
    var root = openPop && openPop.root;
    if (!root) return;
    var rows = root.querySelectorAll('.sfa-modal__option');
    rows.forEach(function (r) { r.disabled = true; });
    row.classList.add('is-loading');
    var priceEl = row.querySelector('.sfa-modal__option-price');
    var originalPrice = priceEl ? priceEl.textContent : '';
    if (priceEl) priceEl.textContent = 'Adding…';

    addToCart(row.getAttribute('data-variant-id'))
      .then(function () {
        closeSelector();
      })
      .catch(function () {
        rows.forEach(function (r) { r.disabled = false; });
        row.classList.remove('is-loading');
        if (priceEl) {
          priceEl.textContent = 'Try again';
          setTimeout(function () { priceEl.textContent = originalPrice; }, 2500);
        }
      });
  }

  /* ---------------- Global listeners ---------------- */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPop) closeSelector();
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Variant row inside an open selector
    var row = e.target.closest('.sfa-modal__option');
    if (row && openPop && openPop.root.contains(row)) {
      if (row.disabled) return;
      e.preventDefault();
      handleOptionClick(row);
      return;
    }

    // Click outside an open in-card popup closes it
    if (openPop && openPop.type === 'card' && !openPop.root.contains(e.target) && !e.target.closest('.sfa-quick-add__btn')) {
      closeSelector();
    }

    // Quick add button on a card
    var btn = e.target.closest('.sfa-quick-add__btn');
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('[data-sfa-quick-add]');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();

    // Products with variants: open the selector
    if (btn.hasAttribute('data-sfa-open-modal')) {
      var dataEl = wrap.querySelector('[data-sfa-product]');
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }
      // Only one variant? Skip the selector and add it straight to cart.
      if (data.variants && data.variants.length === 1) {
        directAdd(btn, data.variants[0].id);
        return;
      }
      openSelector(data, btn);
      return;
    }

    // Single-variant products: add straight to cart
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    directAdd(btn, id);
  });
})();
